import emojiTranslationTable from '@/asset-manager/emoji-translation-table';
import * as EscapeHtml from 'escape-html';
import * as EmojiRegex from 'emoji-regex'
import {MediaUtil} from './MediaUtil';

const emojiRegex = EmojiRegex();

export class TextUtil {
    static replaceEmojisInText(text) {
        let escapedText = EscapeHtml(text);

        return escapedText.replace(emojiRegex, function (emoji) {
            if (emojiTranslationTable.hasOwnProperty(emoji)) {
                let mediaUrl = MediaUtil.getMediaUrl(emojiTranslationTable[emoji].small);

                return `<img src="${mediaUrl}" />`;
            }

            return emoji;
        });
    }
}